import React, { Component } from 'react'
import { Button,Select,Input,message,Modal } from 'antd'
import SearchRetrieve from '../../common/SearchRetrieve.new';
import API_URL from '../../../common/url';
import UploadFile from '../../common/UploadFile';
import ExportUtil from '../../../common/ExportUtil';

const mouthdata = [1,2,3,4,5,6,7,8,9,10,11,12]
const seasondata = ['Q1','Q2','Q3','Q4']
const accountLedgerdata = [
    '510130-1021.',
    '510120-1021.',
    '510130-2002.',
    '510120-2002.',
    '510130-1082.',
    '510120-1082.',
    '510130-1011.',
    '510120-1011.',
    '510130-2011.',
    '510101-0101.',
    '510101-0102.',
    '510101-0190.',
    '510101-0193.',
    '510101-0302.',
]
class Filter extends Component {

    state = {
        yearNum: '',
        uploading:false,
        uploadMes:{
            hasError:false,
            successNum:0,
            failNum:0,
            totalNum:0,
        }
    }


    handleChange = (value, key) => {
        const { searchParams, onChange } = this.props;
        if( key == 'customer') {
            const { value: id, text: name } = value;
            searchParams[`${key}id`] = id;
            searchParams[`${key}Name`] = name;
        }else if( key == 'investigation') {
            const { value: id, text: name } = value;
            searchParams[`${key}Id`] = id;
            searchParams[`${key}Name`] = name;
        }else if (key == 'quarterNum'){
            if(searchParams.quarterNum !== null){
                searchParams.monthNum = null;
                searchParams[key] = value;
            }
        }else {
            searchParams[key] = value;
        }
        onChange(searchParams);
    }

    onUplodChange = (file,fileList)=> {
        if (file.status == "done") {
            if (file.response.error) {  
                message.error(file.response.error);
                file.status = 'removed';
            } else {
                const {uploadMes} = this.state;
                uploadMes.hasError=file.response.hasError;
                uploadMes.successNum=file.response.success;
                uploadMes.failNum=file.response.fail;
                uploadMes.totalNum=file.response.total;
                Modal.confirm({
                    iconType: 'exclamation-circle',
                    title: <div style={{ marginLeft: 42 }}>本次导入的报表数据:</div>,
                    content: `总条数 ${uploadMes.totalNum} 条，导入成功 ${uploadMes.successNum} 条，导入失败 ${uploadMes.failNum} 条。`,
                    onOk: () => {
                        if(uploadMes.hasError){
                            this.downErrorReport();
                        }
                        this.setState({uploading:false});
                    },
                    onCancel: () => {
                        this.setState({uploading:false});
                    },
                    okText: uploadMes.hasError ? '下载错误报告' : '确定',
                    cancelText: '关闭',
                });
            }
        }else{
            this.setState({uploading:true});
        }
    }
    downErrorReport = ()=>{
        ExportUtil.export(null, null, API_URL.dashboard.exportFailRecords);
        message.success('正在下载中!')
    }
    render() {
        const { curRole } = sessionStorage;
        const isFIN = curRole === 'FIN';
        const { searchParams, search, Currencylist, stageList = [], businessList = [] } = this.props;
        const {uploading} = this.state;
        const Option =Select.Option
        const mouthoption = mouthdata.map(i => <Option key={String(i)}>{i}</Option>);
        const seasonoption = seasondata.map(i => <Option key={String(i)}>{i}</Option>);
        const accountLedgerOption = accountLedgerdata.map(i => <Option key={String(i)}>{i}</Option>);
        const currencyoption = Currencylist.map(i => <Option key={String(i.currencyCode)}>{i.currencyName}</Option>);
        const yeardata = [];
        for (let i = 2018 ; i <= searchParams.year; i++) {
            yeardata.push(i)
        }
        const yearOption = yeardata.map( el => <Option key={String(el)} >{el}</Option>);
        const stageOption = stageList.map(el => <Option key={el.typeValue} value={el.typeValue}>{el.typeValue}</Option>);
        const businessOption = businessList.map(el => <Option key={el.typeValue} value={el.typeValue}>{el.typeValue}</Option>);
        return (
            <div>
            <div className="search-bar">
                <div className="search-item">
                    <label htmlFor="" className="ui-label">年份</label>
                    <Select
                        placeholder="请选择"
                        style={{width:120}}
                        showSearch
                        value={searchParams.yearNum}
                        onChange={value => this.handleChange(value,'yearNum')}
                    >
                        {yearOption}
                    </Select>
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">季度</label>
                    <Select
                        placeholder="请选择"
                        style={{width:120}}
                        mode="multiple"
                        value={searchParams.quarterNum}
                        onChange={value => this.handleChange(value,'quarterNum')}
                    >
                    {seasonoption}
                    </Select>
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">月份</label>
                    <Select
                        placeholder="请选择"
                        style={{width:120}}
                        value={searchParams.monthNum}
                        onChange={value => this.handleChange(value,'monthNum')}
                    >
                        {mouthoption}
                    </Select>
                </div>
                <div className="search-item">
                    <label className="ui-label">JDE主项目号</label>
                    <Input
                        placeholder="请输入"
                        style={{width: 150}}
                        value={searchParams.jdeMainCode}
                        onChange={e => this.handleChange(e.target.value,'jdeMainCode')}
                    ></Input>
                </div>
                <div className="search-item">
                    <label className="ui-label">JDE项目号</label>
                    <Input
                        placeholder="请输入"
                        style={{width: 150}}
                        value={searchParams.projectCode}
                        onChange={e => this.handleChange(e.target.value,'projectCode')}
                    ></Input>
                </div>
                <div className="search-item">
                    <label className="ui-label">项目识别码</label>
                    <Input
                        placeholder="请输入"
                        style={{width: 150}}
                        value={searchParams.identifyCode}
                        onChange={e => this.handleChange(e.target.value,'identifyCode')}
                    ></Input>
                </div>
                <div className="search-item">
                    <label className="ui-label">项目简称</label>
                    <SearchRetrieve
                        keyword='investigationName'
                        style={{ width: 182 }}
                        placeholder="输入项目简称检索"
                        value={searchParams.investigationName}
                        params={{ limit: 20 }}
                        url={API_URL.investigation.queryInvestigationByName}
                        config={{ id: 'investigationId', name: 'investigationName' }}
                        onChange={(option) => this.handleChange(option, 'investigation')}
                    />
                </div>
                <div className="search-item">
                    <label className="ui-label">项目阶段</label>
                    <Select
                        placeholder="请选择"
                        allowClear
                        style={{width:120}}
                        value={searchParams.stageNames}
                        onChange={value => this.handleChange(value,'stageNames')}
                    >
                        {stageOption}
                    </Select>
                </div>
                <div className="search-item">
                    <label className="ui-label">业务线</label>
                    <Select
                        placeholder="请选择"
                        allowClear
                        style={{width:120}}
                        value={searchParams.lineOfBusinessString}
                        onChange={value => this.handleChange(value,'lineOfBusinessString')}
                    >
                        {businessOption}
                    </Select>
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">客户名称</label>
                    <SearchRetrieve
                        keyword='customerCompanyName'
                        style={{ width: 160 }}
                        placeholder="请输入客户名称检索"
                        value={searchParams.customerName}
                        params={{ limit: 20 }}
                        url={API_URL.investigation.queryCustomerCompanyByName}
                        config={{ id: 'customerCompanyId', name: 'customerCompanyName' }}
                        onChange={(option) => this.handleChange(option, 'customer')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">客户JDE号</label>
                    <Input
                        placeholder="请输入"
                        style={{width: 150}}
                        value={searchParams.customerJdeCode}
                        onChange={e => this.handleChange(e.target.value,'customerJdeCode')}
                    ></Input>
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">科目账-明细账</label>
                    <Select
                        placeholder="请选择"
                        style={{width:120}}
                        value={searchParams.accountLedger}
                        onChange={value => this.handleChange(value,'accountLedger')}
                        mode="multiple"
                    >
                        {accountLedgerOption}
                    </Select>
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">币种</label>
                    <Select
                        placeholder="请选择"
                        style={{width:100}}
                        allowClear={true}
                        onChange={value => this.handleChange(value,'currency')}
                        value={searchParams.currency}
                        
                    >
                        {currencyoption}
                    </Select>
                </div>
                <div className="search-bar flex-end" >
                    <div className="search-item">
                        <Button type="primary" onClick={search}>搜索</Button>
                        <Button type="primary" onClick={this.props.export}>导出</Button>
                        {isFIN && <Button type="primary" onClick={this.props.downloadTemplate}>下载模板</Button>}
                        {isFIN && <UploadFile
                            uploadUrl={API_URL.dashboard.importIncomeReportForms}
                            showUploadList={false}
                            onChange={this.onUplodChange}
                        >
                            <Button type="primary" disabled={uploading}>导入数据</Button>
                        </UploadFile>}
                    </div>
                </div>
            </div>
        </div>
        )
    }
}

export default Filter


// WEBPACK FOOTER //
// ./src/components/financeManagement/incomestatement/Filter.js